module.exports = __webpack_public_path__ + "static/img/ezn-foundation.cb54989.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/ezn-foundation.jpg
// module id = geRr
// module chunks = 0